import { Nullable } from '@cast/leadcast-types';

export const poolStatuses = ['Active', 'Inactive', 'Removed', 'None'] as const;
type PoolStatus = (typeof poolStatuses)[number];

export const siteTypes = ['Standard', 'Alternate', 'None'] as const;
type SiteType = (typeof siteTypes)[number];

export const lcrTiers = ['1', '2', '3', 'N'] as const;
type LCRTier = (typeof lcrTiers)[number];

export const samplePoolCategories = [
  'i',
  'ii',
  'iii',
  'iv',
  'v',
  'vi',
  'vii',
  'viii',
  'ix',
  'x',
  'xi',
  'xii',
  'xiii',
  'xiv',
] as const;
type SamplePoolCategory = (typeof samplePoolCategories)[number];

export interface SamplePoolEntry {
  id: string;
  propertyId: string;
  name: Nullable<string>;
  samplePointId: Nullable<string>;
  leadcastTier: Nullable<string>;
  status: PoolStatus;
  siteType: SiteType;
  category: SamplePoolCategory;
  lcrTier: LCRTier;
  createdOn: Date;
  updatedOn: Nullable<Date>;
  deletedOn: Nullable<Date>;
}

export class SamplePoolEntry {}
